import React, { FC, ReactNode } from 'react';
import cx from 'clsx';
import { usePersonHighlight } from '../../usePersonHighlight';
import styles from './style.module.scss';

type SubsectionLayoutProps = {
  left: ReactNode;
  right: ReactNode;
  onClick: () => void;
  /** Asset / user id: hovering lights up the same person in the other lists. */
  personId?: string;
  /** Marks this row for the "Wat moet ik doen?" guide; `undecided` while nobody has said whether they help. */
  guide?: { name: string; undecided: boolean; alarmCreator?: boolean; organisation?: boolean };
};

/**
 * Layout for a subsection.
 * This is abstracted out, because every subsection may have a different implementation, but will always the same layout
 */
export const SubsectionLayout: FC<SubsectionLayoutProps> = ({
  left,
  right,
  onClick,
  personId,
  guide,
}) => {

  const { highlighted, hoverProps } = usePersonHighlight(personId);

  return (
    <div
      className={cx(
        styles.subsectionContainer,
        onClick && styles.clickable,
      )}
      onClick={onClick}
      data-guide-target={guide ? 'responder' : undefined}
      data-guide-name={guide?.name}
      data-guide-undecided={guide?.undecided ? '' : undefined}
      data-guide-creator={guide?.alarmCreator ? '' : undefined}
      data-guide-organisation={guide?.organisation ? '' : undefined}
      {...hoverProps}
    >
      <div className={cx(styles.subsectionLayout, highlighted && styles.highlighted)}>
        <div className={styles.left}>
          {left}
        </div>
        <div className={styles.right}>
          {right}
        </div>
      </div>
    </div>
  );

};
